module.exports = [
  require('./gift_of_alacrity'),
  require('./gravity_fissure'),
  require('./gravity_sinkhole'),
]
